
import { RevButtonBase } from '@ds/components/ButtonBase'

import ClickOutside from '@core/directives/ClickOutside'

import NavigationSubMenu from './NavigationSubMenu.vue'

export default {
  components: {
    RevButtonBase,
    NavigationSubMenu,
  },

  directives: {
    ClickOutside,
  },
  props: {
    navigationItems: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      selected: undefined,
      delay: undefined,
    }
  },
  methods: {
    select(item, timeout = 300) {
      this.delay = setTimeout(() => {
        this.selected = item
      }, timeout)
    },
    reset() {
      clearTimeout(this.delay)
    },
    close() {
      this.selected = undefined
    },
  },
}
